import React from 'react';
import { Typography } from '@mui/material';
import { ContractView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Payer template with archived styling
 */
export const PayerTemplate: React.FC<{ rowData: ContractView }> = ({ rowData }) => {
  const isArchived = rowData.status === 'Archived';
  return (
    <Typography
      variant="body2"
      sx={{
        fontWeight: 500,
        opacity: isArchived ? 0.6 : 1,
        backgroundColor: isArchived ? '#f1f5f9' : 'transparent',
      }}
    >
      {rowData.payer || '-'}
    </Typography>
  );
};

// Template function for grid column
export const payerTemplate = (rowData: ContractView) => <PayerTemplate rowData={rowData} />;

export default PayerTemplate;
